import React from 'react';
import Dialog from 'seedly-component-library/dialog';
import RewardCtaCard from 'components/reward/RewardCtaCard';
import { FileText, MessageSquare, Users } from 'react-feather';
import { rewardOnboarding } from 'theme';
import Image from 'next/image';

const HowModal = props => {
  const { isOpen, setModalOpen } = props;

  const CTAData = [
    {
      icon: <Users size={40} />,
      actionText: 'Start a Discussion',
      creditEarn: 100,
    },
    {
      icon: <FileText size={40} />,
      actionText: 'Publish an Opinion',
      creditEarn: 100,
    },
    {
      icon: <MessageSquare size={40} />,
      actionText: 'Comment/Reply',
      creditEarn: 100,
    },
    {
      icon: <Image src={rewardOnboarding.star} height={40} width={40} />,
      actionText: 'Write a Review',
      creditEarn: 200,
    },
  ];

  return (
    <Dialog
      isOpen={isOpen}
      headerTitle="How can I earn Seeds & Credits?"
      onCloseClick={() => setModalOpen(false)}
      widthSize="sm"
    >
      <div className="flex flex-col gap-6 w-full lg:w-auto">
        <p>
          You can earn seeds and credits when you perform the following actions
          on Seedly.
        </p>
        <div className="grid grid-cols-2 gap-4">
          {CTAData.map((data, index) => (
            <RewardCtaCard
              key={index}
              icon={data.icon}
              actionText={data.actionText}
              creditEarn={data.creditEarn}
            />
          ))}
        </div>
        <p>
          There is a limit on the number of Credits you can earn in each month
          depending on your tier
        </p>
        <p>
          Millionaire: Max 1,200 <br />
          Billionaire: Max 3,000 <br />
          Trillionaire: Max 5,000
        </p>
      </div>
    </Dialog>
  );
};

export default HowModal;
